<template>
    <div>
        <v-card elevation="0">
            <v-card-text>
                <v-row dense>
                    <v-col cols="12" v-if="currentinfo.length > 0">
                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th class="text-left">Name</th>
                                    <th class="text-left">Employee#</th>
                                    <th class="text-left">Filled on</th>
                                    <th class="text-left">Filled by</th>
                                    <th class="text-left">Comment</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="record in currentinfo" :key="record.postingFillCreatedTimestamp">
                                    <td>{{ record.applicant.firstname+" "+record.applicant.lastname }}</td>
                                    <td>{{ record.applicant.employeenumber }}</td>
                                    <td>{{ convertTime(record.postingFillCreatedTimestamp) }}</td>
                                    <td>{{ record.postingFillCreatedByCommonName }}</td>
                                    <td>
                                        <v-tooltip left>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon x-small v-bind="attrs" v-on="on"><v-icon>mdi-comment-outline</v-icon></v-btn>
                                            </template>
                                            <span style="white-space: pre-line">{{ record.fillcomment }}</span>
                                        </v-tooltip>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                    <v-col cols="12"></v-col>
                    <v-col cols="12">
                        Candidates with offer letters sent:
                    </v-col>
                    <v-col cols="12">
                        <v-select v-model="selectedCandidate" outlined dense hide-details :items="offerletterapplicants" return-object label="Candidates with Offer Letters for this posting" :menu-props="{ closeOnContentClick: true}">
                            <template v-slot:item="{ item }">
                                <v-list-item two-line @click="selectedCandidate = item">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ item.applicant.firstname+" "+item.applicant.lastname }}</v-list-item-title>
                                        <v-list-item-subtitle>Email: {{ item.applicant.preferredemail }} / Employee No: {{ item.applicant.employeenumber }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                            <template v-slot:selection="{ item }">
                                {{ item.applicant.firstname+" "+item.applicant.lastname }}
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols="12"><v-divider></v-divider></v-col>
                    <v-col cols="12" v-if="Object.keys(selectedCandidate).length > 0">
                        <v-row dense>
                            <v-col cols="6">
                                Selected candidate for this posting: <br /><br />
                                <b>Name: </b>{{ selectedCandidate.applicant.firstname+" "+selectedCandidate.applicant.lastname }}<br />
                                <b>Employee Number: </b>{{ selectedCandidate.applicant.employeenumber }}<br />
                                <b>Email: </b>{{ selectedCandidate.applicant.preferredemail }}
                            </v-col>
                            <v-col cols="6">
                                <v-textarea rows="3" label="Comment" outlined v-model="comment" dense></v-textarea>
                            </v-col>
                            <v-col cols="12"></v-col>
                            <v-col cols="12" class="d-flex justify-center">
                                <v-btn color="#00A8A8" outlined :loading="fillpostingloading" @click="updatePostingFilled">Mark this posting Filled</v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" v-else class="text-center">
                        <br />Please select candidate from above to fill this posting.<br />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
export default {
    props: {
        posting: {
            required: true
        }
    },
    data(){
        return {
            host: location.hostname.toString(),
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            offerletterapplicants: [],
            selectedCandidate: {},
            fillpostingloading: false,
            comment: "",
            currentinfo: []
        }
    },
    methods: {
        closeDialog(){
            this.$emit("reloadEvent");
        },
        loadInfo(){
            const that = this;
            that.currentinfo = that.posting.hasOwnProperty("filled")? that.posting.filled : [];
        },
        loadApplicants(){
            const that = this;
            
            that.loadInfo();

            that.offerletterapplicants = [];
            let applicantID = [];
            if(that.posting.hasOwnProperty('offerLetterCandidates') && that.posting.offerLetterCandidates.length > 0){
                that.posting.offerLetterCandidates.reverse().forEach(element => {
                    if(!(applicantID.includes(element.applicant.id))){
                        applicantID.push(element.applicant.id);
                        that.offerletterapplicants.push(element);
                    }
                });
                that.selectedCandidate = that.offerletterapplicants[0];
            }
        },
        convertTime(time){
            let date = new Date(parseFloat(time));

            return date.toDateString()+", "+String(date.getHours()).padStart(2, '0')+":"+String(date.getMinutes()).padStart(2, '0')+":"+String(date.getSeconds()).padStart(2, '0');
        },
        updatePostingFilled(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            that.fillpostingloading = true;
            let data = {
                id: that.posting.id,
                applicant: {
                    id: that.selectedCandidate.applicant.id,
                    uid: that.selectedCandidate.applicant.uid,
                    firstname: that.selectedCandidate.applicant.firstname,
                    lastname: that.selectedCandidate.applicant.lastname,
                    employeenumber: that.selectedCandidate.applicant.employeenumber
                },
                fillcomment: that.comment
            };

            const formData = new FormData();

            formData.append("mode", "postingfill");
            formData.append("data", JSON.stringify(data));

            //API calling
            fetch(api,{
                    method: "POST",
                    body: formData
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.setSnackbar("Posting Marked Filled", "#388E3C"); //green
                    }

                    that.fillpostingloading = false;
                    that.closeDialog();
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.fillpostingloading = false;
                    that.closeDialog();
                })
            //End of API calling
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.loadApplicants();
    }
}
</script>